module.exports = __webpack_public_path__ + "img/9.2416d396.jpg";